import { useState } from 'react';
import { useTracking } from 'react-tracking';

import { Modal, Grid } from '@simplywallst/ui-core';

import { supportedCurrencies } from '@/constants/currencies';
import type { CurrencyISO } from '@/constants/currencies';

import { Dropdown } from '@components/Dropdown';

import { useChangeAggregatePortfolioCurrency } from './hooks/useChangeAggregatePortfolioCurrency';

type Props = {
  currency: CurrencyISO;
  onClose: () => void;
};

export const UpdateAggregatePortfolioCurrencyModal = ({
  onClose,
  currency,
}: Props) => {
  const { trackEvent } = useTracking();
  const [portfolioCurrency, setPortfolioCurrency] = useState(currency);

  const { mutate, status } = useChangeAggregatePortfolioCurrency({
    onSuccess: () => {
      onClose();
    },
  });

  const handleClick = () => {
    trackEvent({
      action: 'click',
      modifier: 'changeAggregatePortfolioCurrency',
    });
    mutate({
      currency: portfolioCurrency,
    });
  };

  return (
    <Modal
      scrollable={false}
      title="Select a currency"
      primaryLabel="Save"
      secondaryLabel="Cancel"
      onSecondaryClick={onClose}
      onPrimaryClick={handleClick}
      primaryLoading={status === 'pending'}
    >
      <Grid gap="24px">
        <Dropdown
          styleType="standardReverse"
          name="aggregatePortfolioCurrency"
          label="Currency"
          options={supportedCurrencies}
          value={portfolioCurrency}
          onSelect={(option: string) =>
            setPortfolioCurrency(option as CurrencyISO)
          }
        />
      </Grid>
    </Modal>
  );
};
